import { render, staticRenderFns } from "./SettingRS.vue?vue&type=template&id=32bc834d&scoped=true"
import script from "./SettingRS.vue?vue&type=script&lang=js"
export * from "./SettingRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc834d",
  null
  
)

export default component.exports